import { useCallback, useMemo } from 'react'
import { filterOpportunities } from '../-lib/opportunity-filter'
import type { OpportunityListItem } from './useOpportunities'

interface UseOpportunityFilterOptions {
  /** オポチュニティ一覧 */
  opportunities: OpportunityListItem[]
  /** 検索テキスト */
  searchText: string
  /** 検索テキスト設定関数 */
  setSearchText: (text: string) => void
}

/**
 * オポチュニティのフィルタリングとタグクリック処理を提供するカスタムフック
 *
 * 検索テキストに基づいてオポチュニティをフィルタリングし、
 * タグがクリックされた際に検索テキストにタグ名を追加します。
 */
export function useOpportunityFilter(options: UseOpportunityFilterOptions) {
  const { opportunities, searchText, setSearchText } = options

  // 検索によるフィルタリング（カスタム検索対応）
  const filteredOpportunities = useMemo(() => {
    if (!searchText) return opportunities
    return filterOpportunities(opportunities, searchText)
  }, [opportunities, searchText])

  // タグクリックで検索テキストにタグ名を追加
  const handleTagClick = useCallback(
    (tagName: string) => {
      // tag:タグ名 形式で検索テキストに追加（CustomSearchCaptainのパーサーに合わせる）
      const tagQuery = `tag:${tagName}`
      if (searchText.includes(tagQuery)) {
        // 既に検索テキストに含まれている場合は何もしない
        return
      }
      // 検索テキストが空でなければスペースを挟んで追加
      const newSearchText = searchText ? `${searchText} ${tagQuery}` : tagQuery
      setSearchText(newSearchText)
    },
    [searchText, setSearchText],
  )

  return {
    filteredOpportunities,
    handleTagClick,
  }
}
